function isWeb () {
  var userAgent = navigator.userAgent.toLowerCase()
  return userAgent.indexOf('electron') === -1
}

function getSender () {
  if (window.electron) {
    return window.electron.ipcRenderer
  }
  window.electron = window.require('electron')
  window.Admzip = window.require('adm-zip')
  window.dayjs = window.require('dayjs')
  window.fs = window.require('fs')
  window.request = window.require('request')
  window.logger = window.require('electron-log')
  console.log(window.electron)
  return window.electron.ipcRenderer
}
function getRemote () {
  if (window.electron) {
    return window.electron.remote
  }
  window.electron = window.require('electron')
  console.log(window.electron)
  return window.electron.remote
}
function getShell () {
  if (window.electron) {
    return window.electron.shell
  }
  window.electron = window.require('electron')
  return window.electron.shell
}
const myIpcSend = {
  debug: false,
  ipcSender ($router, param = {}, param1 = {}, param2 = {}) {
    if (isWeb()) {
      return $router.push({ path: param2 })
    } else {
      const r = getSender()
      r && r.send(param, param1)
      if (typeof ($router) !== 'undefined' && param !== 'open-main-win' && JSON.stringify(param2) !== '{}') {
        $router.push({ path: param2 })
      }
    }
  },
  ipcRemote () {
    return getRemote()
  },
  renderer () {
    return getSender()
  },
  isWebType () {
    return isWeb()
  },
  openExternal (url) {
    const shell = getShell()
    if (!shell) {
      console.log('Shell is undefined.')
      return
    }
    shell.openExternal(url)
  }
}
export default myIpcSend
